import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
   providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      
      /* request = request.clone({
         setHeaders: {
           'X-Custom-Header': 'mi-valor-personalizado'
         }
       });
 */
      return next.handle(request);
   }
}
